import { jsx as _jsx } from "react/jsx-runtime";
import cn from "classnames";
const PillContainer = ({ items, active, setActiveTab }) => {
    return (_jsx("div", { className: "pill-container", children: items.map((item, index) => (_jsx("button", { className: cn("pill-container__item", active === item && "pill-container__item--active"), onClick: () => setActiveTab(item), children: item }, item + index))) }));
};
export default PillContainer;
